// extracted by mini-css-extract-plugin
module.exports = {"triangle":"Triangle_triangle__1OfB7"};